import Vue from 'vue'
import getDynamicBlock from '../../graphql/b2c/getDynamicBlock'
import config from 'config'
import contentMapping from '../../functions/contentMapping'

export default {
  state: {
    content: {},
    contentPromotion: '',
    formError: '',
    faqs: '',
    externalQuery: '',
    scrollPosition: '',
    trsCollapsePos: 0,
    trsConfirmAction: false,
    trsFormSentMode: '',
    popupContent: {},
  },
  getters: {
    content: (state, _getters, _rootState, rootGetters) =>
    contentMapping(state.content, rootGetters.quoteType === 'TRS'),
    faqs: (state) => state.faqs,
    externalQuery: (state) => state.externalQuery,
    trsCollapsePos: (state) => state.trsCollapsePos,
    trsConfirmAction: (state) => state.trsConfirmAction,
    trsFormSentMode: (state) => state.trsFormSentMode,
  },
  mutations: {
    SET_EXTERNAL_QUERY(state, externalQuery) {
      state.externalQuery = externalQuery
    },
    RESET_EXTERNAL_QUERY_PAYMENT_REDIRECT(state, externalQuery) {
      state.externalQuery.paymentRedirect = externalQuery
    },
    SET_CONTENT(state, content) {
      state.content = content
    },
    SET_CONTENT_PROMOTION(state, contentPromotion) {
      state.contentPromotion = contentPromotion
    },
    SET_FAQS(state, faqs) {
      state.faqs = faqs
    },
    SET_SCROLL_POSITION(state, position) {
      state.scrollPosition = position
      // immediately scroll to set position.
      window.scrollTo({
        top: position,
        behavior: 'smooth',
      })
    },
    SET_FORM_ERROR(state, error) {
      state.formError = error
    },
    SET_TRS_CONFIRM_ACTION(state, trsConfirmAction) {
      state.trsConfirmAction = trsConfirmAction
    },
    SET_TRS_COLLAPSE_POS(state, position) {
      state.trsCollapsePos = position
    },
    TRS_FORM_SENT_MODE(state, trsFormSentMode) {
      state.trsFormSentMode = trsFormSentMode
    },
    SET_POPUP_CONTENT(state, content) {
      state.popupContent = content
    },
  },
  actions: {
    setFormError(context, formError) {
      context.commit('SET_FORM_ERROR', formError)
    },
    async getContentDefault(context) {
      const locale = context.getters.locale
      const defaultLeadsource = {
        NL: 'SUNGEVITY_NL',
        BE: 'SUNGEVITY_FLANDERS',
      }[locale.slice(-2)]

      const key = `${locale}/${defaultLeadsource}`
      const content =
        await require(/* webpackChunkName: "lang-[request]" */ `translations/frontend/${key}.json`)
      context.commit('SET_CONTENT', content)
    },
    async getContent(context) {
      const { languageId, configurationId, locale } = context.getters
      const key = `${locale}/${languageId || configurationId}`
      const [content, { faq }] = await Promise.all([
        require(/* webpackChunkName: "lang-[request]" */ `translations/frontend/${key}.json`),
        require(/* webpackChunkName: "faq-[request]" */ `translations/faq/${key}.json`),
      ])

      context.commit('SET_CONTENT', content)

      const faqs = Object.entries(faq).sort((a, b) => Number(a[0]) > Number(b[0]))
      context.commit(
        'SET_FAQS',
        faqs.map((f) => ({ id: f[0], ...f[1] }))
      )
    },
    async getContentPromotion(context) {
      // do check if referralcode exists
      if (context.getters.iquote && context.getters.iquote.referralCode) {
        const datoCmsUrl = 'https://graphql.datocms.com/'
        const request = getDynamicBlock(context.getters.locale, context.getters.iquote.referralCode)
        const response = await Vue.$http.post(datoCmsUrl, request, {
          headers: { Authorization: `Bearer ${config.datocms.key}` },
        })

        if (response.data) {
          const { data } = response.data
          context.commit('SET_CONTENT_PROMOTION', data.dynamicBlock)
        } else {
          throw new Error('Error fetching dynamic block')
        }
      }
      return null
    },
  },
}
